module.exports = __webpack_public_path__ + "static/heydiddlediddle-e03d717495d1145b0bec62a8de79c167.png";